import type { MoveResolution } from "./game/helpers";

export type Theme = "liquid-glass" | "neon-puzzle" | "strata-minimal";

export type MoveHint =
  | "none"
  | "match"
  | "build"
  | "ten-clear"
  | "negative"
  | "zero-clear"
  | "illegal";

export type TileColor = {
  name: string;
  hex: string;
};

export const THEME_ORDER: Theme[] = ["liquid-glass", "neon-puzzle", "strata-minimal"];

export const THEME_CONFIG: Record<Theme, { name: string }> = {
  "liquid-glass": { name: "Liquid Glass" },
  "neon-puzzle": { name: "Neon Puzzle" },
  "strata-minimal": { name: "Strata Minimal" }
};

export const TILE_COLORS: Record<number, TileColor> = {
  1: { name: "Bright Blue", hex: "#2D9CFF" },
  2: { name: "Aqua", hex: "#1DD6C7" },
  3: { name: "Mint Green", hex: "#4CE38A" },
  4: { name: "Lime", hex: "#9BE23A" },
  5: { name: "Gold", hex: "#FFD84D" },
  6: { name: "Orange", hex: "#FF9A3A" },
  7: { name: "Coral", hex: "#FF6F61" },
  8: { name: "Pink", hex: "#FF5DAA" },
  9: { name: "Purple", hex: "#8A5CFF" }
};

export const NEGATIVE_TILE_COLORS: Record<number, TileColor> = {
  1: { name: "Sky Blue", hex: "#58B4FF" },
  2: { name: "Seafoam Aqua", hex: "#43E3D4" },
  3: { name: "Fresh Mint", hex: "#68EAA0" },
  4: { name: "Citron", hex: "#B6EC61" },
  5: { name: "Sun Gold", hex: "#FFE375" },
  6: { name: "Apricot Orange", hex: "#FFB15C" },
  7: { name: "Soft Coral", hex: "#FF8A80" },
  8: { name: "Bloom Pink", hex: "#FF7CC0" },
  9: { name: "Lavender Violet", hex: "#A37BFF" }
};

export function getTileColor(value: number): TileColor {
  if (value < 0) {
    return NEGATIVE_TILE_COLORS[Math.abs(value)] ?? NEGATIVE_TILE_COLORS[1];
  }

  return TILE_COLORS[value] ?? TILE_COLORS[1];
}

export function isDangerTile(value: number): boolean {
  return value >= 8;
}

export function moveHintFromOutcome(outcome: MoveResolution["outcome"]): MoveHint {
  if (outcome === "match_clear") {
    return "match";
  }

  if (outcome === "build") {
    return "build";
  }

  if (outcome === "build_to_ten_clear") {
    return "ten-clear";
  }

  if (outcome === "negative_reduce") {
    return "negative";
  }

  if (outcome === "negative_clear") {
    return "zero-clear";
  }

  return "illegal";
}
